import { Chip, cn } from "@moanhot/ui";
import { NUM, TD, TH, when } from "@/screens/format";
import { useAdminLoad } from "@/screens/hooks";
import { EmptyNote, LoadState, Page, Table } from "@/screens/ui";

const rate = (r: number | null) => (r === null ? "" : `${(r * 100).toFixed(1)}%`);

/** Partner webhook endpoints, failing first, and how much the delivery worker has queued. */
export function WebhookHealth() {
  const [load] = useAdminLoad((a) => a.webhookHealth(), [], "Could not load webhook health.");
  return (
    <Page title="Webhook health">
      <LoadState load={load} empty={(d) => (d.data.length === 0 ? <EmptyNote title="No endpoints" body="No tenant has added a webhook endpoint yet." /> : null)}>
        {(d) => (
          <>
            <p className="mb-4 text-sm text-ink-2">
              Delivery queue: <span className="font-mono tabular-nums text-ink">{d.queue_depth}</span> waiting
            </p>
            <Table
              label="Endpoints"
              head={
                <>
                  <th className={TH}>Endpoint</th>
                  <th className={TH}>Tenant</th>
                  <th className={TH}>State</th>
                  <th className={cn(TH, "text-right")}>Deliveries 7 d</th>
                  <th className={cn(TH, "text-right")}>Failed</th>
                  <th className={TH}>Last success</th>
                </>
              }
            >
              {d.data.map((e) => (
                <tr key={e.endpoint_id}>
                  <td className={cn(TD, "max-w-[36ch] break-all font-mono text-xs")}>
                    {e.url}
                    <div className="text-ink-3">
                      {e.endpoint_id} {e.mode}
                    </div>
                  </td>
                  <td className={TD}>{e.tenant_name}</td>
                  <td className={TD}>
                    {e.enabled ? <Chip className={e.failing_since ? "text-warn" : "text-ok"}>{e.failing_since ? "Failing" : "On"}</Chip> : <Chip className="text-err">Disabled</Chip>}
                    {e.disabled_reason && <div className="text-xs text-ink-3">{e.disabled_reason}</div>}
                  </td>
                  <td className={NUM}>{e.deliveries_7d}</td>
                  <td className={cn(NUM, (e.failure_rate_7d ?? 0) > 0.1 && "text-err")}>
                    {e.failed_7d}
                    <div className="text-xs">{rate(e.failure_rate_7d)}</div>
                  </td>
                  <td className={cn(TD, "text-xs")}>{when(e.last_success_at)}</td>
                </tr>
              ))}
            </Table>
          </>
        )}
      </LoadState>
    </Page>
  );
}
